/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Categorical attribute filter component
 * - allows user to update the data type of the attribute
 * - renders list of distinct category and allow user to include/exclude the category
 * - update the order of the category
 * Component will send the message which will be subscribed by the plot view to make the necessary change
 */

import React from 'react';
import Raphael from 'raphael';
import CategoryColorPickerComponent from '../CategoryColorPickerComponent.jsx';
import ResetFilterComponent from './ResetFilterComponent.jsx';
import CheckboxGroup from '../../common/CheckboxGroup.jsx';
import CheckboxListSelection from '../../common/CheckboxListSelection.jsx';
import ToolTip from '../../common/ToolTip.js';

class CategoryListComponent extends React.Component {
  constructor(props) {
    super(props)
    let Dyn = this.props.Dyn;

    //Dyn.dataSet.getAttributeByID( this.props.attributeObj.id ).isFiltered();

    // TODO - attribute change to numeric to categorical expects explicit change to
    // toString on the value. However, it doesnt detect when excluding the cases.

    // get the list of checked categories
    var filter = Dyn.dataSet.caseFilter.getAttributeFilter( this.props.attributeObj.id ),
        allCategories = this.props.attributeObj.statsPreFilter.categories,
        includedCategories = []; //filter ? filter.categories : this.props.attributeObj.statsPreFilter.categories;
    $.each( allCategories, function( index, value ) {
        var excluded = filter && filter.categories.indexOf( value ) >= 0;
        if( ! excluded ) includedCategories.push( value );
    });
    this.state = {
        value: includedCategories
    };
  }


  // Get category color to display along with the checklist of category
  getCategoryColor = (categoryValue) => {
    let Dyn = this.props.Dyn;

    var colorString = Dyn.colorUtil.calcCategoryColor(
      this.props.attributeObj.statsPreFilter,
      this.props.attributeObj.color,
      categoryValue,
      false,
      this.props.attributeObj.colorMap,
      this.props.attributeObj.isSortAscending).colorString,
      rgbValue = Raphael.getRGB(colorString);

    return {
      "backgroundColor": rgbValue.hex
    };
  }

  /* deprecated
  componentWillReceiveProps = ( nextProps ) => {
    let Dyn = this.props.Dyn;
    var filter = Dyn.dataSet.caseFilter.getAttributeFilter( this.props.attributeObj.id ),
      allCategories = this.props.attributeObj.statsPreFilter.categories,
      activeCategories = [];

    // get union of existing filter and non-selected categories
    if ( filter ) {
      $.each( allCategories, function( index, value ) {
        if( filter.categories.indexOf( value ) === -1 )  {
          activeCategories.push( value );
        }
      });
    } else {
      activeCategories = allCategories;
    }

    // setState in componentWillReceiveProps won't rerender the comoponent
    this.setState({
      value: activeCategories
    }, function(){
      var checkboxes = this.refs.categoryGroup.getCheckboxes();
      for (var i = 0; i < checkboxes.length; i++) {
        if (activeCategories.indexOf(checkboxes[i].value) === -1) {
          checkboxes[i].checked = false;
        }
      }
    });
  }
  */

  componentDidUpdate(prevProps) {
    if (this.props.attributeObj.id !== prevProps.attributeObj.id) {
      let Dyn = this.props.Dyn;
      var filter = Dyn.dataSet.caseFilter.getAttributeFilter(this.props.attributeObj.id),
        allCategories = this.props.attributeObj.statsPreFilter.categories,
        activeCategories = [];

      if (filter) {
        allCategories.forEach((value) => {
          if (filter.categories.indexOf(value) === -1) {
            activeCategories.push(value);
          }
        });
      } else {
        activeCategories = allCategories;
      }

      this.setState({
        value: activeCategories
      }, this.updateCheckboxes);
    }
  }

  updateCheckboxes = () => {
    var checkboxes = this.refs.categoryGroup.getCheckboxes();
    checkboxes.forEach(checkbox => {
      checkbox.checked = this.state.value.includes(checkbox.value);
    });
  }

  getLoc = (str) => {
    let Dyn = this.props.Dyn;
      return Dyn.loc( str );
  }

  handleToggleCategories = (isChecked) => {
    isChecked ? this.handleClear() : this.handleReset();
  }

  render = () => {
    // the checkboxes can be arbitrarily deep. They will always be fetched and
    // attached the `name` attribute correctly. `value` is optional
    return (
        <div className="tde-categorical-component tde-mt-4 tde-pt-4 tde-divider-top tde-divider-bottom tde-pb-4">
            <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                <div className="tde-row">
                    <div className="tde-label tde-s1 tde-font-weight-bold tde-attr-name">
                        { this.getLoc('Filter Categories') }<ToolTip tip={this.getLoc('Uncheck categories to filter/remove from plotting area')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip>
                    </div>

                    {/* <div className="tde-input" style={{textAlign:'right'}}>
                        <ResetFilterComponent handleChange={this.handleReset} value={ this.getLoc('Select All') } attributeObj={ this.props.attributeObj } isFiltered={ this.props.isFiltered }/>
                        <PlainButton onClick={this.handleReset}>{ this.getLoc('Clear') }</PlainButton>
                    </div>
                    */}
                </div>
                <div className="tde-s1 tde-font-weight-bold tde-attr-name tde-align-center tde-mt-3 tde-mb-3">
                    <div>
                        <CheckboxListSelection
                            lableStr={this.getLoc('Select all')}
                            id="tde-categories-group"
                            checkboxListStatus={this.state.value.length === this.props.attributeObj.statsPreFilter.categories.length
                                                ? 'all': this.state.value.length === 0
                                                ? 'none' : 'partial' }
                            checkboxOnClick={this.handleToggleCategories}
                            showClearButton = {true}
                            selectedIems = {this.state.value.length}
                            handleClear = {this.handleClear}
                            getLoc = {this.getLoc}
                            />
                    </div>
                </div>


                <div className="tde-checkbox-section tde-pl-0 tde-ml-0">
                <CheckboxGroup
                    name="categories"
                    role="group"
                    key="categoriesGroup"
                    aria-label={this.getLoc('Categories')}
                    value={this.state.value}
                    ref="categoryGroup"
                    onChange={this.handleChange}
                >
                    { this.props.attributeObj.statsPreFilter.categories.map(function(item, i) {
                    if ( this.props.attributeObj.statsPreFilter.getCategoricIndvCaseCount(item) > 0 ) {
                        return <label key={i}><input id={`tde-attr-filter-${i}`} key={i} type="checkbox" value={item} className="tde-mx-0"/>
                        <CategoryColorPickerComponent
                        Dyn = { this.props.Dyn }
                        attributeObj={ this.props.attributeObj } categoryObj={ item } />
                        <span className="tde-s1 tde-font-weight-regular tde-attr-name tde-word-break" dangerouslySetInnerHTML={{ __html: item + " ("+ this.props.attributeObj.statsPreFilter.getCategoricIndvCaseCount(item) + ")" }}></span></label>;
                    }
                    }.bind(this)) }
                </CheckboxGroup>
                </div>
            </div>
        </div>
    );
  }


  handleSelectAll = () => {
    //basically clear the filter, and it should take care of checkboxes

    _gaq.push(
    ['_trackEvent', 'Filter Function', 'Click', 'AttributeFilterSelectAll']);
    // publish the message to reset the filter applied for the attribute
    this.handleCategoryFilter();

    var checkboxes = this.refs.categoryGroup.getCheckboxes();
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = true;
    }
  }


  handleClear = () => {

    //get all checked values and pass it apply filter on
    _gaq.push(['_trackEvent', 'Filter Function', 'Click', 'AttributeFilterClear']);

    var selectedCategories = this.refs.categoryGroup.getCheckedValues(),
        checkboxes = [],
        allCategories = [];

    if( selectedCategories.length > 0 ) {

      this.props.attributeObj.statsPreFilter.categories.map(
        (function (item, i){
          allCategories.push(item);
      }).bind(this))

      //required to set all the values so that it doesn't checkmark again
      this.setState({
        value: []
      });

      checkboxes = this.refs.categoryGroup.getCheckboxes();
      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = false;
      }

      // publish message to update the cases in plot and in legend area
      this.handleCategoryFilter(allCategories);
  }

  }

  handleReset = () => {
      // this.props.handleChange
      this.setState({
        value: this.props.attributeObj.statsPreFilter.categories
      });
      this.handleCategoryFilter([]);
  }


  handleChange = () => {

    // will return the currently selected checkbox values as an array, possibly empty
    var filteredCategories = this.refs.categoryGroup.getUncheckedValues();

    this.setState({
      value: this.refs.categoryGroup.getCheckedValues()
    }, () => {

      // publish message to update the cases in plot and in legend area
      this.handleCategoryFilter(filteredCategories);

    });

  }

  handleCategoryFilter = (filteredCategories) => {
      // To call the parent and rerender the component
      this.props.handleChange({
          isFiltered: filteredCategories.length > 0,
          dataType: 'categorical',
          filtered: filteredCategories
      });
  }
}

export default CategoryListComponent
